import { ForwardingOrderInfo, TransportOrderInfo } from "../../../api";
type DeliveryCardProps = {
  delivery: TransportOrderInfo | ForwardingOrderInfo;
};

const isTransportOrderInfo = (
  delivery: TransportOrderInfo | ForwardingOrderInfo | undefined,
): delivery is TransportOrderInfo => delivery?.type === "TransportOrder";

export default function DeliveryCard({ delivery }: DeliveryCardProps) {
  const loadingDate = isTransportOrderInfo(delivery)
    ? delivery.loading_date
    : delivery.date;

  const supplierName = isTransportOrderInfo(delivery)
    ? delivery.supplier?.name || "Brak dostawcy"
    : "";

  const buyerOrClientName = isTransportOrderInfo(delivery)
    ? delivery.buyer?.name || "Brak kupującego"
    : delivery.client?.name || "Brak klienta";

  return (
    <div className="delivery-card">
      <div className="flex-container delivery-time-place">
        <div>
          {loadingDate
            ? new Date(loadingDate).toLocaleDateString("pl-PL")
            : "brak daty"}
        </div>
        <div className="delivery-place">
          <span>{supplierName}</span>
          <i
            className="pi pi-arrow-right"
            style={{ fontSize: "0.8rem", color: "#A5A8AC" }}
          ></i>
          <span>{buyerOrClientName}</span>
        </div>
      </div>
      <div className="delivery-details">
        {isTransportOrderInfo(delivery) ? "zlecenia transportowe" : "spedycja"}
        <i
          className="pi pi-truck"
          style={{ fontSize: "0.8rem", color: "#A5A8AC" }}
        ></i>
        <div>
          <span className={!delivery.truck_number ? "no-vehicle" : ""}>
            {delivery.truck_number ? delivery.truck_number : "brak ciężarówki"}
          </span>
          <span>, </span>
          <span className={!delivery.trailer_number ? "no-vehicle" : ""}>
            {delivery.trailer_number
              ? delivery.trailer_number
              : "brak przyczepy"}
          </span>
        </div>
      </div>
    </div>
  );
}
